import cloneDeep from 'lodash/cloneDeep'

const state = {
  // 是否登陆
  isLogin: false,
  // 是否加入企业
  hasCompany: false,
  // 产品开通状态
  openedProducts: {},
  // 产品开启状态
  openedStatus: {},
  // 用户信息数据
  userInfo: {},
  // 当前公司信息
  companyInfo: {},
  // 当前页面路由名称
  currentTab: null,
  // 当前页面路由地址
  currentHref: null,
  // 子组件名称，用于判断是否调用消息接口
  childName: '',
  // 站内消息数量
  noticeCount: 0
}

const mutations = {
  // 修改用户数据
  setUserInfo(state, data) {
    state.userInfo = cloneDeep(data)
    state.isLogin = data && data.userId ? true : false
    state.hasCompany = data && data.companyStatus === 20
  },

  // 修改当前公司信息
  setCompanyInfo(state, data) {
    state.companyInfo = cloneDeep(data)
  },

  getUserInfo() {
    return state.userInfo
  },

  getCompanyInfo() {
    return state.companyInfo
  },

  // 修改登陆状态
  setIsLogin(state, data) {
    state.isLogin = data
  },

  // 修改加入企业状态
  setHasCompany(state, data) {
    state.hasCompany = data
  },

  // 设置产品开通状态
  setOpenedProducts(state, data) {
    state.openedProducts = data
  },

  // 设置产品开启状态
  setOpenedStatus(state, data) {
    state.openedStatus = data
  },

  setCurrentTab(state, data) {
    state.currentTab = cloneDeep(data)
  },

  setCurrentHref(state, data) {
    state.currentHref = cloneDeep(data)
  },

  setChildName(state, data) {
    state.childName = cloneDeep(data)
  },

  // 设置站内消息数量
  setNoticeCount(state, data) {
    state.noticeCount = cloneDeep(data)
  }
}

const actions = {
  // 退出登录
  logout({ commit, state, dispatch }) {
    return new Promise((resolve, reject) => {
      // commit('setToken', '')
      // 清除用户数据
      commit('setUserInfo', {})
      // 清除当前公司信息
      commit('setCompanyInfo', {})
      // 设置登录状态为false
      commit('setIsLogin', false)

      resolve()
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
